import styled from 'styled-components';

import { buttonBaseStyles } from '../Button';

export const IconButton = styled.button`
  ${buttonBaseStyles}
`;
